import schedulesViewStateStore from "../store/store";
import { IBaseConflictEntity } from "sh-models";
import { mutatorAction } from "satcheljs";
import { ObservableMap } from "mobx";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";

export default mutatorAction('SET_CONFLICTS_IN_VIEW', function setConflictsInView(
    conflictsInView: ObservableMap<string, IBaseConflictEntity[]>,
    viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
) {
    let store = viewState ? viewState : schedulesViewStateStore();
    store.conflictsInView = conflictsInView;
});
